import React, { Fragment } from "react";
import { Box, Center, constants } from "@thecb/components";

import AdministeredUsersTable from "@/components/administeredUsers";
import connectUserPermissions from "@/components/currentUser/CurrentUserPermissions";
import AlertBar from "@/components/alert-bar";
import ToastNotification from "@/components/generic/ToastNotification";
import InternalUserInfo from "@/components/internalUserInfo";
import { ADD, EDIT, PERSONAL_INFORMATION } from "@/constants/formTypes";
import { CONTENT_MAX_WIDTH } from "@/constants/layout";

const { SPACING } = constants.styleConstants;

const UserSettingsPage = ({
  actions,
  activateUser,
  alertBars,
  allAgencyOptions,
  allSelected,
  closeCreateForm,
  closeEditForm,
  closePersonalInfoForm,
  closeToastNotification,
  createUserWorkflowIsOpen,
  currentUser,
  currentUsersAdministeredRoles,
  deactivateUser,
  editUserWorkflowIsOpen,
  fetchAgencyOptions,
  forms,
  isPOSEnabled,
  modificationStatuses,
  personalInfoWorkflowIsOpen,
  roleCombinations,
  selectAgency,
  selectedAgencies,
  setSelectedAgencies,
  submitAddUser,
  submitEditUser,
  submitPersonalInfo,
  toastNotificationContent,
  toastNotificationIsOpen,
  toggleSelectAllAgencies,
  userBeingAdded,
  userBeingEdited,
  userCanActivateUser,
  userCanDeactivateUser,
  userCanGrantAgencyMembershipToUser,
  userIsBeingChecked,
}) => {
  const {
    editUserInfoForm: editForm,
    addUserInfoForm: addForm,
    personalInfoForm: personalInfoForm,
  } = forms;
  const {
    forms: {
      editUserInfoForm: editFormActions,
      addUserInfoForm: addFormActions,
      personalInfoForm: personalInfoFormActions,
    },
    alertBars: {
      editUserInfoAlertBar: editUserAlertBarActions,
      addUserInfoAlertBar: addUserAlertBarActions,
      personalInfoAlertBar: personalInfoAlertBarActions,
      userSettingsPageAlertBar: settingsAlertBarAction,
    },
  } = actions;
  const {
    editUserInfoAlertBar: editAlertBar,
    addUserInfoAlertBar: addAlertBar,
    personalInfoAlertBar: personalInfoAlertBar,
    userSettingsPageAlertBar: settingsAlertBar,
  } = alertBars;

  return (
    <Fragment>
      <ToastNotification
        toastOpen={toastNotificationIsOpen}
        content={toastNotificationContent}
        closeToastNotification={closeToastNotification}
      />
      {!createUserWorkflowIsOpen &&
        !editUserWorkflowIsOpen &&
        !personalInfoWorkflowIsOpen && (
          <Fragment>
            {settingsAlertBar.alerts.length > 0 && (
              <Center maxWidth={CONTENT_MAX_WIDTH} gutters={SPACING.MD}>
                <Box
                  padding="1rem 0"
                  extraStyles={`max-width: ${CONTENT_MAX_WIDTH};`}
                >
                  <AlertBar {...settingsAlertBar} {...settingsAlertBarAction} />
                </Box>
              </Center>
            )}
            <AdministeredUsersTable />
          </Fragment>
        )}
      {personalInfoWorkflowIsOpen && userCanGrantAgencyMembershipToUser && (
        <InternalUserInfo
          formType={PERSONAL_INFORMATION}
          form={personalInfoForm}
          formActions={personalInfoFormActions}
          submitType={submitPersonalInfo}
          alertBar={personalInfoAlertBar}
          alertBarActions={personalInfoAlertBarActions}
          closeForm={closePersonalInfoForm}
          currentUser={currentUser}
          userIsBeingChecked={userIsBeingChecked}
        />
      )}
      {createUserWorkflowIsOpen && userCanGrantAgencyMembershipToUser && (
        <InternalUserInfo
          formType={ADD}
          form={addForm}
          formActions={addFormActions}
          submitType={submitAddUser}
          alertBar={addAlertBar}
          alertBarActions={addUserAlertBarActions}
          closeForm={closeCreateForm}
          roleOptions={currentUsersAdministeredRoles}
          allAgencyOptions={allAgencyOptions}
          fetchAgencyOptions={fetchAgencyOptions}
          setSelectedAgencies={setSelectedAgencies}
          modificationStatuses={modificationStatuses}
          currentUser={currentUser}
          userBeingAdded={userBeingAdded}
          userBeingEdited={userBeingEdited}
          selectedAgencies={selectedAgencies}
          allSelected={allSelected}
          toggleSelectAllAgencies={toggleSelectAllAgencies}
          selectAgency={selectAgency}
          isPOSEnabled={isPOSEnabled}
          roleCombinations={roleCombinations}
        />
      )}
      {editUserWorkflowIsOpen && userCanGrantAgencyMembershipToUser && (
        <InternalUserInfo
          formType={EDIT}
          form={editForm}
          formActions={editFormActions}
          submitType={submitEditUser}
          activateUser={activateUser}
          alertBar={editAlertBar}
          alertBarActions={editUserAlertBarActions}
          closeForm={closeEditForm}
          deactivateUser={deactivateUser}
          userCanActivateUser={userCanActivateUser}
          userCanDeactivateUser={userCanDeactivateUser}
          roleOptions={currentUsersAdministeredRoles}
          allAgencyOptions={allAgencyOptions}
          fetchAgencyOptions={fetchAgencyOptions}
          setSelectedAgencies={setSelectedAgencies}
          modificationStatuses={modificationStatuses}
          currentUser={currentUser}
          userBeingEdited={userBeingEdited}
          selectedAgencies={selectedAgencies}
          allSelected={allSelected}
          toggleSelectAllAgencies={toggleSelectAllAgencies}
          selectAgency={selectAgency}
          isPOSEnabled={isPOSEnabled}
          roleCombinations={roleCombinations}
        />
      )}
    </Fragment>
  );
};

export default connectUserPermissions(UserSettingsPage);
